import styled, { css } from 'styled-components';
import { media } from '@prisjakt/ui-base';

export const ITEMS_DESKTOP = 4;
export const ITEMS_TABLET = 3;
export const ITEMS_MOBILE = 2;

const GAP_DESKTOP = 1;
const GAP_TABLET = 1;
const GAP_MOBILE = 0.5;

const SIZE_TABLET = `${100 / ITEMS_TABLET}%`;
const SIZE_MOBILE = `${100 / ITEMS_MOBILE}%`;

const GUTTER_MOBILE = `(${GAP_MOBILE *
  (ITEMS_MOBILE - 1)}rem / ${ITEMS_MOBILE})`;

const GUTTER_TABLET = `(${GAP_TABLET *
  (ITEMS_TABLET - 1)}rem / ${ITEMS_TABLET})`;

export const OffersGrid = styled.ul<{ isWide?: boolean }>(props => {
  const itemsDesktop = props.isWide ? 5 : ITEMS_DESKTOP;
  const sizeDesktop = `${100 / itemsDesktop}%`;
  const gutterDesktop = `(${GAP_DESKTOP *
    (itemsDesktop - 1)}rem / ${itemsDesktop})`;

  return css`
    @supports (grid-template-columns: repeat(auto-fill, minmax(auto, 50%))) {
      display: grid;
      flex: 1 0 auto;
      list-style: none;
      grid-gap: ${GAP_MOBILE}rem;
      grid-template-columns: repeat(
        auto-fill,
        minmax(auto, calc(${SIZE_MOBILE} - ${GUTTER_MOBILE}))
      );

      ${media.mediumOnly`
      grid-gap:${GAP_TABLET}rem;
      grid-template-columns: repeat(auto-fill, minmax(auto, calc(${SIZE_TABLET} - ${GUTTER_TABLET})));
    `};

      ${media.largeUp`
      grid-gap: ${GAP_DESKTOP}rem;
      grid-template-columns: repeat(auto-fill, minmax(auto, calc(${sizeDesktop} - ${gutterDesktop})));
    `};
    }

    /* Fallback to flex if grid-template-columns is not supported */
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  `;
});

export const OffersGridItem = styled.li``;
